import { call, put } from "redux-saga/effects";
import { Types } from "../actionTypes";
import API from "@Api";
import Member from "@accessdev/member-management/classes/Member";

const pageSize = 1000;

export function* addMembers(action) {
  try {
    const data = yield call(API.admin.adminAddMembers, action);
    yield put({ type: Types.ADMIN_ADD_MEMBERS_SUCCESS, data });
  } catch (error) {
    console.error(error);
    if (error.status === 403) {
      yield put({ type: Types.ADMIN_TOOL_UNAUTHORIZED });
    }
    yield put({ type: Types.ADMIN_ADD_MEMBERS_FAILURE, error });
  }
}

export function* editMember(action) {
  try {
    const data = yield call(API.admin.adminEditMember, action);
    yield put({
      type: Types.ADMIN_EDIT_MEMBER_SUCCESS,
      payload: {
        member: new Member(data),
        previousMemberKey: action.member.member_key,
      },
    });
  } catch (error) {
    console.error(error);
    if (error.status === 403) {
      yield put({ type: Types.ADMIN_TOOL_UNAUTHORIZED });
    }
    yield put({ type: Types.ADMIN_EDIT_MEMBERS_FAILURE });
  }
}

export function* getMembers(action) {
  const { searchValue, mergeResponse } = action;
  try {
    const data = yield call(API.admin.adminGetMembers, action);
    const isSearching = typeof searchValue === "string" && searchValue.length > 2;
    yield put({
      type: Types.ADMIN_GET_MEMBERS_SUCCESS,
      payload: {
        members: data.members.map((member) => new Member(member)),
        totalPages: Math.ceil(data.total_results / pageSize),
        totalMembers: data.total_results,
        mergeResponse: mergeResponse || false,
        isSearching,
      },
    });
  } catch (error) {
    console.error(error);
    if (error.status === 403) {
      yield put({ type: Types.ADMIN_TOOL_UNAUTHORIZED });
    }
    yield put({ type: Types.ADMIN_GET_MEMBERS_FAILURE, error });
  }
}

export function* getMember(action) {
  try {
    const response = yield call(API.admin.adminGetMember, action);
    yield put({
      type: Types.ADMIN_GET_MEMBER_SUCCESS,
      response: new Member(response),
    });
  } catch (error) {
    console.error(error);
    if (error.status === 403) {
      yield put({ type: Types.ADMIN_TOOL_UNAUTHORIZED });
    }
    yield put({ type: Types.ADMIN_GET_MEMBER_FAILURE });
  }
}

export function* getActiveMemberCount(action) {
  try {
    const response = yield call(API.admin.adminGetActiveMemberCount, action.payload);
    yield put({
      type: Types.ADMIN_GET_ACTIVE_MEMBER_COUNT_SUCCESS,
      payload: response,
    });
  } catch (error) {
    console.error(error);
    if (error.status === 403) {
      yield put({ type: Types.ADMIN_TOOL_UNAUTHORIZED });
    }
    yield put({ type: Types.ADMIN_GET_ACTIVE_MEMBER_COUNT_FAILURE });
  }
}
